import { useEffect } from "react";
import { salesActions } from "redux/Ldb/actions";
import { useAppDispatch, useAppSelector } from "../storeHooks";

const useUpdateSalesSettings = () => {
    const dispatch = useAppDispatch();
    const { updatingSalesSettings, updateSalesSettingsSuccess, updateSalesSettingsFailure } =
        useAppSelector((state) => state.sales);

    const updateSettings = (data: Record<string, any>) => {
        dispatch(salesActions.updateSalesSettings(data));
    };

    const resetSuccess = () => {
        dispatch(salesActions.resetUpdateSalesSettingsSuccess());
    };

    return {
        updatingSalesSettings,
        updateSalesSettingsSuccess,
        updateSettings,
        resetSuccess,
    };
};

export default useUpdateSalesSettings;
